/* Cipton free gift: LED Basketball (either size) or a Safari ball in cart -> Ball Pump added at qty 1, tagged _cipton_gift.
   Basketball leaves -> the tagged pump leaves. Pumps added by the customer on purpose are never touched.
   The "Free gift" automatic discount (Shopify admin) makes the pump $0; this only saves the click. */
(function () {
  var BALLS = [45907720405157, 45669979259045, 42523548385445, 42523551662245]; /* LED 29.5, LED 28.5, Emerald Safari, Electric Safari */
  var PUMP = 48255254823077;
  var busy = false;

  function bundledSections() {
    var s = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: s } }));
    return s;
  }
  function cfg(body) {
    var c = (window.theme && theme.utils && theme.utils.fetchConfig) ? theme.utils.fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
    c.body = JSON.stringify(body);
    return c;
  }
  function publish(cart) {
    if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'cipton-free-gift', cart: cart });
  }
  function refresh() {
    return fetch(theme.routes.cart_update_url, cfg({ updates: {}, sections: bundledSections() }))
      .then(function (r) { return r.json(); }).then(publish);
  }
  function sync() {
    if (busy) return;
    busy = true;
    fetch(theme.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasBall = false, pump = null, giftLine = null;
        cart.items.forEach(function (it) {
          if (BALLS.indexOf(it.variant_id) > -1) hasBall = true;
          if (it.variant_id === PUMP) {
            pump = it;
            if (it.properties && it.properties._cipton_gift === '1') giftLine = it;
          }
        });
        if (hasBall && !pump) {
          return fetch(theme.routes.cart_add_url, cfg({ items: [{ id: PUMP, quantity: 1, properties: { _cipton_gift: '1' } }] }))
            .then(function (r) { return r.json(); }).then(refresh);
        }
        if (!hasBall && giftLine) {
          return fetch(theme.routes.cart_change_url, cfg({ id: giftLine.key, quantity: 0, sections: bundledSections() }))
            .then(function (r) { return r.json(); }).then(publish);
        }
        if (giftLine && giftLine.quantity !== 1) {
          return fetch(theme.routes.cart_change_url, cfg({ id: giftLine.key, quantity: 1, sections: bundledSections() }))
            .then(function (r) { return r.json(); }).then(publish);
        }
      })
      .catch(function (e) { console.error('cipton-free-gift', e); })
      .then(function () { busy = false; });
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart && e.detail.cart.source === 'cipton-free-gift') return;
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
